'use client'

import classes from './form-error-message.module.css'

import { Group, Text } from '@mantine/core'
import { CircleX } from 'lucide-react'
import { useTranslations } from 'next-intl'

type FormErrorMessageProps = {
  message: string | null
}

const FormErrorMessage = (props: FormErrorMessageProps) => {
  const { message } = props

  const t = useTranslations('auth')

  if (!message) return null

  return (
    <Group className={classes.containerMessage} gap='sm'>
      <CircleX nonScalingStroke size={16} strokeWidth={1} />
      <Text
        className={classes.errorMessage}
        dangerouslySetInnerHTML={{ __html: t(message) }}
      />
    </Group>
  )
}

export default FormErrorMessage
